"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTenantSpecificLocales = exports.defaultLocales = void 0;
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var IntlProvider_1 = require("@empiriecom/module-components/IntlProvider");
exports.defaultLocales = ['de-DE', 'de-AT', 'de-CH', 'fr-CH'];
var getTenantSpecificLocales = function (localesToSwitch) {
    return localesToSwitch || exports.defaultLocales;
};
exports.getTenantSpecificLocales = getTenantSpecificLocales;
var userPreferredLocale = function (location, defaultLoc, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
localesToSwitch) {
    if (defaultLoc === void 0) { defaultLoc = ''; }
    // regular
    var userLocale = IntlProvider_1.getUserLocale() || defaultLoc;
    var cookies = new universal_cookie_1.default();
    var preferredLocale = cookies.get('PreferredLocale') || userLocale;
    // const locales = getTenantSpecificLocales(localesToSwitch);
    var locales = exports.defaultLocales;
    var currentLocation = location || null;
    var currentLocationLoc = preferredLocale;
    if (currentLocation) {
        var lastLoc_1 = '';
        locales.forEach(function (loc) {
            if (lastLoc_1 !== loc) {
                var language = loc.substring(0, 2);
                if (currentLocation.indexOf("/" + language + "/") !== -1 || currentLocation === "/" + language) {
                    currentLocationLoc = loc;
                }
                lastLoc_1 = loc;
            }
        });
        return currentLocationLoc;
    }
    return currentLocationLoc;
};
exports.default = userPreferredLocale;
//# sourceMappingURL=userPreferredLocale.js.map